<template>
    <MeetingDetailsBlock
        iconName="check"
        title="Service"
    >
        {{ service.title }}
    </MeetingDetailsBlock>
</template>

<script setup lang="ts">
    import { type PropType } from 'vue'
    import MeetingDetailsBlock from '@/App/Booking/Meeting/Component/MeetingDetailsBlock.vue'
    import Service from '@/App/Service/Entity/Service'

    const props = defineProps({
        service: {
            type: Object as PropType<Service>,
            required: true,
        },
    })
</script>
